(() => {
  function toStr(value) {
    return typeof value === "string" ? value.trim() : value == null ? "" : String(value).trim();
  }
  function normalizeKey(value) {
    return toStr(value).toLowerCase();
  }
  function escapeHtml(value) {
    return toStr(value).replaceAll("&", "&amp;").replaceAll("<", "&lt;").replaceAll(">", "&gt;").replaceAll('"', "&quot;").replaceAll("'", "&#39;");
  }
  function titleCase(value) {
    return toStr(value).replace(/\b([a-z])/g, (match) => match.toUpperCase());
  }
  function formatChoiceDisplayTitle(value) {
    const raw = toStr(value);
    if (!raw) return "";
    return raw.split(/\s+/).map((token) => {
      if (!token) return token;
      if (/\//.test(token) || /\d/.test(token)) return token;
      return token.split(/(-)/).map((part) => {
        if (part === "-") return part;
        if (!/^[A-Z]+$/.test(part)) return part;
        const lowered = part.toLowerCase();
        return lowered.charAt(0).toUpperCase() + lowered.slice(1);
      }).join("");
    }).join(" ");
  }
  function formatTypeSubLabel(value) {
    const raw = toStr(value);
    if (!raw) return "";
    const normalized = typeof raw.normalize === "function" ? raw.normalize("NFKC") : raw;
    return normalized.replace(/[νѵⅴｖ]/g, "v").replace(/[уү]/g, "y").toLowerCase();
  }
  function formatTypeSubDisplay(value) {
    return titleCase(formatTypeSubLabel(value));
  }
  function debugTireWidget(message, details) {
    console.log("[TireWidget]", message, details || "");
  }
  function buildTypeKey(type, typeSub) {
    return `${normalizeKey(type)}__${formatTypeSubLabel(typeSub)}`;
  }
  function normalizeCompactKey(value) {
    return toStr(value).toLowerCase().replace(/[^a-z0-9]+/g, "");
  }
  function parseNumber(value) {
    if (typeof value === "number" && Number.isFinite(value)) {
      return value;
    }
    const raw = toStr(value).replace(",", ".");
    if (!raw) return null;
    const match = raw.match(/-?\d+(?:\.\d+)?/);
    if (!match) return null;
    const parsed = Number(match[0]);
    return Number.isFinite(parsed) ? parsed : null;
  }
  function parseNumericId(value) {
    if (typeof value === "number" && Number.isFinite(value)) {
      return Math.trunc(value);
    }
    const raw = toStr(value);
    if (!raw) return null;
    const match = raw.match(/(\d+)(?:\D*)$/);
    if (!match) return null;
    const parsed = Number(match[1]);
    return Number.isFinite(parsed) ? parsed : null;
  }
  function parseCents(value) {
    if (typeof value === "number" && Number.isFinite(value)) {
      return Math.round(value);
    }
    const raw = toStr(value);
    if (!raw) return 0;
    if (/^-?\d+(\.\d+)?$/.test(raw)) {
      const numeric = Number(raw);
      if (Number.isFinite(numeric)) {
        return raw.includes(".") ? Math.round(numeric * 100) : Math.round(numeric);
      }
    }
    const normalized = raw.replace(/[^0-9.-]/g, "");
    const parsed = Number(normalized);
    if (!Number.isFinite(parsed)) return 0;
    return raw.includes(".") ? Math.round(parsed * 100) : Math.round(parsed);
  }
  function parseBadgeSavingsCents(value) {
    const raw = toStr(value);
    if (!raw) return 0;
    const match = raw.match(/(\d+(?:[.,]\d+)?)/);
    if (!match) return 0;
    const numeric = Number(match[1].replace(",", "."));
    if (!Number.isFinite(numeric) || numeric <= 0) return 0;
    return Math.round(numeric * 100);
  }
  function formatMoney(cents) {
    var _a, _b, _c, _d;
    const amount = (Number(cents) || 0) / 100;
    const currency = ((_b = (_a = window.Shopify) == null ? void 0 : _a.currency) == null ? void 0 : _b.active) || ((_d = (_c = window.Shopify) == null ? void 0 : _c.currency) == null ? void 0 : _d.currency) || window.currency || "USD";
    try {
      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency
      }).format(amount);
    } catch (err) {
      return `$${amount.toFixed(2)}`;
    }
  }
  function parseWheelSize(rawValue) {
    const raw = toStr(rawValue);
    if (!raw) {
      return {
        wheelValue: "",
        wheelLabel: ""
      };
    }
    const numeric = raw.match(/(\d{2})/);
    const wheelValue = numeric ? numeric[1] : raw.replace(/[^0-9]/g, "");
    return {
      wheelValue,
      wheelLabel: wheelValue ? `${Number(wheelValue)}"` : raw
    };
  }
  function compareTireSizes(a, b) {
    const left = toStr(a);
    const right = toStr(b);
    const leftMatch = left.match(/^(\d{3})\/(\d{2,3})R?(\d{2})$/i);
    const rightMatch = right.match(/^(\d{3})\/(\d{2,3})R?(\d{2})$/i);
    if (leftMatch && rightMatch) {
      const leftWidth = Number(leftMatch[1]) || 0;
      const rightWidth = Number(rightMatch[1]) || 0;
      if (leftWidth !== rightWidth) return leftWidth - rightWidth;
      const leftAspect = Number(leftMatch[2]) || 0;
      const rightAspect = Number(rightMatch[2]) || 0;
      if (leftAspect !== rightAspect) return leftAspect - rightAspect;
      const leftRim = Number(leftMatch[3]) || 0;
      const rightRim = Number(rightMatch[3]) || 0;
      if (leftRim !== rightRim) return leftRim - rightRim;
    }
    return left.localeCompare(right, void 0, { numeric: true, sensitivity: "base" });
  }
  function parseRawTireSize(rawValue) {
    const raw = toStr(rawValue);
    if (!raw) {
      return {
        fullLabel: "",
        tireSize: "",
        model: "",
        wheelValue: "",
        wheelLabel: ""
      };
    }
    const normalizedRaw = raw.replace(/\u2013|\u2014/g, "-");
    const sizeMatch = normalizedRaw.match(/\d{3}\/\d{2}R\d{2}/i) || normalizedRaw.match(/\d{3}\/\d{2}\/\d{2}/i);
    const detectedSize = sizeMatch ? toStr(sizeMatch[0]) : "";
    let tireSize = "";
    let model = "";
    const dashSplit = normalizedRaw.split(/\s+-\s+/);
    if (dashSplit.length > 1) {
      tireSize = toStr(dashSplit[0]);
      model = toStr(dashSplit.slice(1).join(" - "));
    } else if (detectedSize) {
      tireSize = detectedSize;
      model = toStr(normalizedRaw.replace(detectedSize, "").replace(/^[\s-]+|[\s-]+$/g, ""));
    } else {
      tireSize = normalizedRaw;
      model = "";
    }
    const rimMatch = tireSize.match(/R\s*(\d{2})/i) || tireSize.match(/(\d{2})\s*["”]?$/);
    const wheelValue = rimMatch ? rimMatch[1] : "";
    const wheelLabel = wheelValue ? `${Number(wheelValue)}"` : "";
    return {
      fullLabel: raw,
      tireSize,
      model,
      wheelValue,
      wheelLabel
    };
  }
  function normalizeFitmentRules(value) {
    const source = value && typeof value === "object" ? value : {};
    return {
      lte1_5: toStr(source.lte1_5 || source.upTo1_5 || source["1_5"] || source["1.5"]),
      between2: toStr(source.between2 || source.range2 || source["2"]),
      gte2_5: toStr(source.gte2_5 || source.from2_5 || source["2_5"] || source["2.5"])
    };
  }
  function normalizeFitmentRanges(value) {
    const source = value && typeof value === "object" ? value : {};
    const lte1_5Max = parseNumber(source.lte1_5Max || source.upTo1_5Max || source.smallMax);
    const between2Min = parseNumber(source.between2Min || source.mediumMin);
    const between2Max = parseNumber(source.between2Max || source.mediumMax);
    const gte2_5Min = parseNumber(source.gte2_5Min || source.from2_5Min || source.largeMin);
    return {
      lte1_5Max: lte1_5Max == null ? 1.5 : lte1_5Max,
      between2Min: between2Min == null ? 1.6 : between2Min,
      between2Max: between2Max == null ? 2.4 : between2Max,
      gte2_5Min: gte2_5Min == null ? 2.5 : gte2_5Min
    };
  }
  function parseLiftHeight(value) {
    return parseNumber(value);
  }
  function getLiftSelectionText() {
    var _a, _b, _c, _d;
    const form = document.querySelector("variant-form-custom");
    const liftGroup = form == null ? void 0 : form.querySelector(".selector--lift");
    if (!liftGroup) return "";
    const checkedValue = toStr((_a = liftGroup.querySelector("input.single-option-selector:checked")) == null ? void 0 : _a.value) || toStr((_b = liftGroup.querySelector("input:checked")) == null ? void 0 : _b.value) || toStr((_c = liftGroup.querySelector("select")) == null ? void 0 : _c.value);
    if (checkedValue) return checkedValue;
    const optionIndex = Number(liftGroup.dataset.optionIndex);
    const normalizedIndex = Number.isInteger(optionIndex) ? optionIndex - 1 : -1;
    if (normalizedIndex >= 0 && Array.isArray((_d = form == null ? void 0 : form.currentVariant) == null ? void 0 : _d.options)) {
      return toStr(form.currentVariant.options[normalizedIndex]);
    }
    if (normalizedIndex >= 0 && Array.isArray(form == null ? void 0 : form.options)) {
      return toStr(form.options[normalizedIndex]);
    }
    return "";
  }
  const FITMENT_COPY = Object.freeze({
    fits: {
      title1: "FITS! NO RUBBING",
      title2: "",
      note: 'W/ Factory Wheels or Max 9" Wheel Width, 0 or Positive Offset'
    },
    nofit: {
      title1: "WITH UCA -> Fits - No Rubbing",
      title2: "NO UCA -> MudFlap Removal & Trimming Likely",
      note: 'W/ Factory Wheels or Max 9" Wheel Width, 0 or Positive Offset'
    }
  });
  function resolveFitmentReference(reference) {
    const normalized = normalizeCompactKey(reference);
    if (normalized === "fits") {
      return FITMENT_COPY.fits;
    }
    if (normalized === "nofit") {
      return FITMENT_COPY.nofit;
    }
    return {
      title1: "",
      title2: "",
      note: ""
    };
  }
  class TireWidget extends HTMLElement {
    connectedCallback() {
      if (this.dataset.tireWidgetInit === "true") {
        this.cacheDom();
        this.bindEvents();
        debugTireWidget("reconnected", {
          hasOverlay: Boolean(this.overlayNode),
          hasPanel: Boolean(this.panelNode)
        });
        return;
      }
      this.dataset.tireWidgetInit = "true";
      this.isLiftKitHost = this.dataset.tireWidgetMode === "lift-kit" || this.tagName.toLowerCase() === "lift-kit-tire-widget";
      this.data = this.readData();
      if (!this.data || !Array.isArray(this.data.choices)) {
        this.style.display = "none";
        return;
      }
      this.choices = this.normalizeChoices(this.data.choices);
      this.fitmentRanges = normalizeFitmentRanges(this.data.fitmentRanges);
      if (!this.choices.length) {
        this.style.display = "none";
        return;
      }
      this.form = this.closest('form[action*="/cart/add"]');
      this.lastEmittedSignature = "";
      this.cacheDom();
      debugTireWidget("connected", {
        isLiftKitHost: this.isLiftKitHost,
        legacyMode: this.legacyMode,
        choices: this.choices.length,
        hasOverlay: Boolean(this.overlayNode),
        hasPanel: Boolean(this.panelNode)
      });
      this.initState();
      this.bindEvents();
      this.registerAddonBridge();
      this.bindVariantPriceUpdates();
      this.render();
    }
    disconnectedCallback() {
      this.unlockBodyScroll();
      if (this.__boundHandleClick) {
        this.removeEventListener("click", this.__boundHandleClick);
      }
      if (this.__boundHandleChange) {
        this.removeEventListener("change", this.__boundHandleChange);
      }
      if (this.__boundHandleKeydown) {
        document.removeEventListener("keydown", this.__boundHandleKeydown);
      }
      if (this.__onVariantChange) {
        document.removeEventListener("variant:change", this.__onVariantChange);
      }
      if (Array.isArray(this.__directButtonCleanup)) {
        this.__directButtonCleanup.forEach((cleanup) => {
          if (typeof cleanup === "function") cleanup();
        });
      }
      this.__eventsBound = false;
      this.__directButtonCleanup = [];
    }
    readData() {
      const node = this.querySelector("[data-tire-widget-data]");
      if (!node) return null;
      try {
        return JSON.parse(node.textContent || "{}");
      } catch (err) {
        console.error("Failed to parse tire widget data:", err);
        return null;
      }
    }
    normalizeChoices(rawChoices) {
      const defaultQuantity = this.isLiftKitHost ? 4 : 1;
      return rawChoices.map((choice, index) => {
        const parsed = parseRawTireSize(choice.rawTireSize || choice.tireSize || "");
        const explicitWheel = parseWheelSize(choice.wheelSize || choice.wheelLabel || "");
        const type = toStr(choice.tireType);
        const typeSub = toStr(choice.tireTypeSub);
        const quantity = Number(choice.setQuantity) || 0;
        const sort = Number(choice.sort) || index + 1;
        const galleryImages = Array.isArray(choice.galleryImages) ? choice.galleryImages.map((image) => toStr(image)).filter(Boolean) : [];
        return {
          id: toStr(choice.id) || String(index + 1),
          rawTireSize: toStr(choice.rawTireSize) || parsed.fullLabel || toStr(choice.tireSize),
          tireSize: toStr(choice.tireSize) || parsed.tireSize || toStr(choice.rawTireSize),
          model: toStr(choice.model) || toStr(choice.variantTitle) || toStr(choice.productTitle) || parsed.model || "",
          wheelValue: explicitWheel.wheelValue || parsed.wheelValue,
          wheelLabel: explicitWheel.wheelLabel || parsed.wheelLabel,
          type,
          typeSub,
          typeFilterDisplay: type,
          typeDisplay: formatTypeSubDisplay(typeSub),
          tireBadge: toStr(choice.discountBadge || choice.tireBadge),
          discountBadge: toStr(choice.discountBadge),
          fitmentRules: normalizeFitmentRules(choice.fitmentRules),
          fitmentTitle1: toStr(choice.fitmentTitle1),
          fitmentTitle2: toStr(choice.fitmentTitle2),
          fitmentNote: toStr(choice.fitmentNote),
          variantId: parseNumericId(choice.variantId),
          variantPrice: parseCents(choice.variantPrice),
          variantCompareAtPrice: parseCents(choice.variantCompareAtPrice),
          variantTitle: toStr(choice.variantTitle),
          variantSku: toStr(choice.variantSku),
          variantImage: toStr(choice.variantImage),
          productId: parseNumericId(choice.productId),
          productHandle: toStr(choice.productHandle),
          productTitle: toStr(choice.productTitle),
          productUrl: toStr(choice.productUrl),
          productDescription: toStr(choice.productDescription),
          galleryImages: galleryImages.length > 0 ? galleryImages : toStr(choice.variantImage) ? [toStr(choice.variantImage)] : [],
          quantity: quantity > 0 ? quantity : defaultQuantity,
          sort
        };
      }).sort((a, b) => a.sort - b.sort);
    }
    cacheDom() {
      this.titleNode = this.querySelector("[data-tw-title]");
      this.openTrigger = this.querySelector("[data-tw-open]");
      this.legacyMode = !this.openTrigger;
      this.cardHeadingNode = this.querySelector("[data-tw-card-heading]");
      this.cardSubtitleNode = this.querySelector("[data-tw-card-subtitle]");
      this.cardMetaNode = this.querySelector("[data-tw-card-meta]");
      this.cardPriceNode = this.querySelector("[data-tw-card-price]");
      this.cardSaveNode = this.querySelector("[data-tw-card-save]");
      this.sectionCopyLabelNode = this.querySelector("[data-tw-section-copy-label]");
      this.sectionCopySaveNode = this.querySelector("[data-tw-section-copy-save]");
      this.cardImageNode = this.querySelector("[data-tw-card-image]");
      this.cardImageFallbackNode = this.querySelector("[data-tw-card-image-fallback]");
      this.overlayNode = this.querySelector("[data-tw-overlay]");
      const overlayScope = this.overlayNode || this;
      this.panelNode = overlayScope.querySelector("[data-tw-panel]");
      this.productCountNode = overlayScope.querySelector("[data-tw-product-count]");
      this.wheelCurrentNode = overlayScope.querySelector("[data-tw-wheel-current]");
      this.wheelBadgeNode = overlayScope.querySelector("[data-tw-wheel-badge]");
      this.wheelHeaderNode = overlayScope.querySelector("[data-tw-wheel-header]");
      this.wheelChevronNode = overlayScope.querySelector("[data-tw-wheel-chevron]");
      this.wheelNode = overlayScope.querySelector("[data-tw-wheel-options]");
      this.sizeNode = overlayScope.querySelector("[data-tw-size-options]");
      this.typeNode = overlayScope.querySelector("[data-tw-type-options]");
      this.sizeSelectNode = overlayScope.querySelector("[data-tw-size-select]");
      this.typeSelectNode = overlayScope.querySelector("[data-tw-type-select]");
      this.sizeDropdownNode = overlayScope.querySelector("[data-tw-size-dropdown]");
      this.typeDropdownNode = overlayScope.querySelector("[data-tw-type-dropdown]");
      this.selectionChipsNode = overlayScope.querySelector("[data-tw-selection-chips]");
      this.modelSectionNode = overlayScope.querySelector("[data-tw-model-section]");
      this.mobileFitmentNode = overlayScope.querySelector("[data-tw-mobile-fitment]");
      this.mobileFitmentTitle1Node = overlayScope.querySelector("[data-tw-mobile-fitment-title-1]");
      this.mobileFitmentTitle2Node = overlayScope.querySelector("[data-tw-mobile-fitment-title-2]");
      this.mobileFitmentNoteNode = overlayScope.querySelector("[data-tw-mobile-fitment-note]");
      this.sheetScrollNode = overlayScope.querySelector("[data-tw-sheet-scroll]");
      this.stepSizeNode = overlayScope.querySelector("[data-tw-step-size]");
      this.stepTypeNode = overlayScope.querySelector("[data-tw-step-type]");
      this.stepModelNode = overlayScope.querySelector("[data-tw-step-model]");
      this.modelNode = overlayScope.querySelector("[data-tw-model-options]");
      this.emptyNode = overlayScope.querySelector("[data-tw-empty]");
      this.applyButton = overlayScope.querySelector("[data-tw-apply]");
      this.clearButton = overlayScope.querySelector("[data-tw-clear]");
      this.previewPanelNode = overlayScope.querySelector("[data-tw-preview-panel]");
      this.previewTrackNode = overlayScope.querySelector("[data-tw-preview-track]");
      this.previewPrevButton = overlayScope.querySelector('[data-tw-action="preview-prev"]');
      this.previewNextButton = overlayScope.querySelector('[data-tw-action="preview-next"]');
      this.previewLiveNode = overlayScope.querySelector("[data-tw-preview-live]");
      this.previewDotsNode = overlayScope.querySelector("[data-tw-preview-dots]");
      this.previewThumbsNode = overlayScope.querySelector("[data-tw-preview-thumbs]");
      this.previewTitleNode = overlayScope.querySelector("[data-tw-preview-title]");
      this.previewBadgeNode = overlayScope.querySelector("[data-tw-preview-badge]");
      this.previewCompareAtNode = overlayScope.querySelector("[data-tw-preview-compare-at]");
      this.previewPriceNode = overlayScope.querySelector("[data-tw-preview-price]");
      this.previewSaveNode = overlayScope.querySelector("[data-tw-preview-save]");
      this.previewSizeNode = overlayScope.querySelector("[data-tw-preview-size]");
      this.previewTypeNode = overlayScope.querySelector("[data-tw-preview-type]");
      this.previewDescriptionSectionNode = overlayScope.querySelector(
        "[data-tw-preview-description-section]"
      );
      this.previewDescriptionNode = overlayScope.querySelector("[data-tw-preview-description]");
      this.fitmentNode = overlayScope.querySelector("[data-tw-fitment]");
      this.fitmentTitle1Node = overlayScope.querySelector("[data-tw-fitment-title-1]");
      this.fitmentTitle2Node = overlayScope.querySelector("[data-tw-fitment-title-2]");
      this.fitmentNoteNode = overlayScope.querySelector("[data-tw-fitment-note]");
      this.propConfig = this.querySelector("[data-tw-prop-config]");
      this.propWheel = this.querySelector("[data-tw-prop-wheel]");
      this.propSize = this.querySelector("[data-tw-prop-size]");
      this.propType = this.querySelector("[data-tw-prop-type]");
      this.propModel = this.querySelector("[data-tw-prop-model]");
      this.propFitment1 = this.querySelector("[data-tw-prop-fitment-1]");
      this.propFitment2 = this.querySelector("[data-tw-prop-fitment-2]");
      this.propFitmentNote = this.querySelector("[data-tw-prop-fitment-note]");
      this.propVariantId = this.querySelector("[data-tw-prop-variant-id]");
      this.propVariantSku = this.querySelector("[data-tw-prop-variant-sku]");
      this.propProductId = this.querySelector("[data-tw-prop-product-id]");
      this.propProductHandle = this.querySelector("[data-tw-prop-product-handle]");
      this.propProductTitle = this.querySelector("[data-tw-prop-product-title]");
      this.propQty = this.querySelector("[data-tw-prop-qty]");
    }
    applyDrawerBaseStyles() {
      if (!this.overlayNode) return;
      Object.assign(this.overlayNode.style, {
        position: "fixed",
        inset: "0",
        zIndex: "10000",
        background: "rgba(17, 17, 17, 0.72)",
        backdropFilter: "blur(8px)",
        WebkitBackdropFilter: "blur(8px)"
      });
      if (this.panelNode) {
        if (this.isMobileDrawerLayout()) {
          Object.assign(this.panelNode.style, {
            position: "fixed",
            top: "auto",
            left: "0",
            right: "0",
            bottom: "0",
            width: "100vw",
            maxWidth: "none",
            height: "auto",
            maxHeight: "min(92vh, calc(100vh - 12px))",
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
            background: "#F2F2F2",
            boxShadow: "0 -24px 56px rgba(15,23,42,0.18)",
            borderTopLeftRadius: "20px",
            borderTopRightRadius: "20px",
            borderBottomLeftRadius: "0",
            borderBottomRightRadius: "0"
          });
        } else {
          Object.assign(this.panelNode.style, {
            position: "fixed",
            top: "0",
            left: "auto",
            right: "0",
            bottom: "0",
            width: "min(498px, calc(100vw - 16px))",
            maxWidth: "100vw",
            height: "100vh",
            maxHeight: "100vh",
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
            background: "#F2F2F2",
            boxShadow: "-24px 0 56px rgba(15,23,42,0.12)",
            borderTopLeftRadius: "0",
            borderTopRightRadius: "0",
            borderBottomLeftRadius: "0",
            borderBottomRightRadius: "0"
          });
        }
      }
    }
    isMobileDrawerLayout() {
      return typeof window !== "undefined" && window.matchMedia("(max-width: 767px)").matches;
    }
    updateDrawerFilterFocusState() {
      const dimGrid = this.openSelectMenu === "size" || this.openSelectMenu === "type";
      if (this.modelSectionNode) {
        this.modelSectionNode.style.opacity = dimGrid ? "0.2" : "1";
        this.modelSectionNode.style.pointerEvents = dimGrid ? "none" : "auto";
        this.modelSectionNode.style.transition = "opacity 180ms ease";
      }
    }
    renderMobileFitmentSection() {
      if (!this.mobileFitmentNode) return;
      const choice = this.getDraftChoice();
      const fitment = this.getResolvedFitment(choice);
      const title1 = toStr(fitment.title1);
      const title2 = toStr(fitment.title2);
      const note = toStr(fitment.note);
      const hasFitment = Boolean(choice && (title1 || title2 || note));
      if (this.mobileFitmentTitle1Node) {
        this.mobileFitmentTitle1Node.textContent = title1;
        this.mobileFitmentTitle1Node.hidden = !title1;
      }
      if (this.mobileFitmentTitle2Node) {
        this.mobileFitmentTitle2Node.textContent = title2;
        this.mobileFitmentTitle2Node.hidden = !title2;
      }
      if (this.mobileFitmentNoteNode) {
        this.mobileFitmentNoteNode.textContent = note;
        this.mobileFitmentNoteNode.hidden = !note;
      }
      this.mobileFitmentNode.hidden = !hasFitment;
    }
    applyDrawerVisibility(isOpen) {
      var _a, _b;
      if (!this.overlayNode) return;
      this.applyDrawerBaseStyles();
      this.overlayNode.style.pointerEvents = isOpen ? "auto" : "none";
      this.overlayNode.style.visibility = isOpen ? "visible" : "hidden";
      this.overlayNode.style.opacity = isOpen ? "1" : "0";
      if (this.panelNode) {
        this.panelNode.style.transform = this.isMobileDrawerLayout() ? isOpen ? "translateY(0)" : "translateY(calc(100% + 16px))" : isOpen ? "translateX(0)" : "translateX(100%)";
        this.panelNode.style.opacity = isOpen ? "1" : "0";
        this.panelNode.style.pointerEvents = isOpen ? "auto" : "none";
      }
      debugTireWidget("apply-visibility", {
        isOpen,
        overlayHidden: this.overlayNode.hidden,
        overlayOpacity: this.overlayNode.style.opacity,
        panelTransform: ((_a = this.panelNode) == null ? void 0 : _a.style.transform) || "",
        panelOpacity: ((_b = this.panelNode) == null ? void 0 : _b.style.opacity) || ""
      });
    }
    initState() {
      if (this.legacyMode) {
        this.state = {
          wheel: "",
          tireSize: "",
          typeKey: "",
          choiceId: "",
          noneSelected: false,
          modelDeselected: true
        };
        const wheelOptions = this.getWheelOptions();
        const defaultKey = normalizeKey(this.data.defaultTireSize);
        const defaultChoice = defaultKey ? this.choices.find((choice) => {
          return normalizeKey(choice.tireSize) === defaultKey || normalizeKey(choice.rawTireSize).includes(defaultKey);
        }) : null;
        this.state.wheel = (defaultChoice == null ? void 0 : defaultChoice.wheelLabel) || wheelOptions[0] || "";
        if (defaultChoice) {
          this.state.tireSize = defaultChoice.tireSize || "";
          this.state.typeKey = buildTypeKey(defaultChoice.type, defaultChoice.typeSub);
        }
        this.syncLegacyStateToAvailable();
        return;
      }
      this.isOpen = false;
      this.openSelectMenu = "";
      this.appliedState = {
        choiceId: ""
      };
      this.draftState = this.getDefaultDraftState();
      this.syncDraftToAvailable();
    }
    getDefaultDraftState() {
      const wheelOptions = this.getWheelOptions();
      const defaultKey = normalizeKey(this.data.defaultTireSize);
      const defaultChoice = defaultKey ? this.choices.find((choice) => {
        return normalizeKey(choice.tireSize) === defaultKey || normalizeKey(choice.rawTireSize).includes(defaultKey);
      }) : this.choices[0] || null;
      return {
        wheel: (defaultChoice == null ? void 0 : defaultChoice.wheelLabel) || wheelOptions[0] || "",
        tireSize: (defaultChoice == null ? void 0 : defaultChoice.tireSize) || "",
        typeKey: defaultChoice ? buildTypeKey(defaultChoice.type, defaultChoice.typeSub) : "",
        choiceId: ""
      };
    }
    getWheelOptions() {
      const wheels = this.choices.map((choice) => choice.wheelLabel).filter(Boolean);
      return [...new Set(wheels)];
    }
    getSizeOptions() {
      return [
        ...new Set(
          this.choices.filter((choice) => {
            if (this.draftState.wheel && choice.wheelLabel !== this.draftState.wheel) return false;
            return true;
          }).map((choice) => choice.tireSize).filter(Boolean)
        )
      ].sort(compareTireSizes);
    }
    getTypeOptions() {
      const mapped = this.choices.filter((choice) => {
        if (this.draftState.wheel && choice.wheelLabel !== this.draftState.wheel) return false;
        return true;
      }).map((choice) => ({
        key: buildTypeKey(choice.type, choice.typeSub),
        type: choice.type,
        typeSub: choice.typeSub,
        display: choice.typeFilterDisplay || choice.type || choice.typeDisplay
      }));
      const seen = /* @__PURE__ */ new Set();
      return mapped.filter((item) => {
        if (seen.has(item.key)) return false;
        seen.add(item.key);
        return true;
      });
    }
    getFilteredChoices() {
      return this.choices.filter((choice) => {
        if (this.draftState.wheel && choice.wheelLabel !== this.draftState.wheel) return false;
        if (this.draftState.tireSize && choice.tireSize !== this.draftState.tireSize) return false;
        if (this.draftState.typeKey) {
          const key = buildTypeKey(choice.type, choice.typeSub);
          if (key !== this.draftState.typeKey) return false;
        }
        return true;
      });
    }
    getChoiceById(choiceId) {
      const id = toStr(choiceId);
      if (!id) return null;
      return this.choices.find((choice) => choice.id === id) || null;
    }
    getAppliedChoice() {
      return this.getChoiceById(this.appliedState.choiceId);
    }
    getDraftChoice() {
      return this.getChoiceById(this.draftState.choiceId);
    }
    syncDraftFromApplied() {
      const appliedChoice = this.getAppliedChoice();
      if (appliedChoice) {
        this.draftState = {
          wheel: appliedChoice.wheelLabel || "",
          tireSize: appliedChoice.tireSize || "",
          typeKey: buildTypeKey(appliedChoice.type, appliedChoice.typeSub),
          choiceId: appliedChoice.id
        };
      } else {
        this.draftState = this.getDefaultDraftState();
      }
      this.syncDraftToAvailable();
    }
    syncDraftToAvailable() {
      var _a;
      const wheelOptions = this.getWheelOptions();
      if (!this.draftState.wheel || !wheelOptions.includes(this.draftState.wheel)) {
        this.draftState.wheel = wheelOptions[0] || "";
      }
      const sizeOptions = this.getSizeOptions();
      if (this.draftState.tireSize && !sizeOptions.includes(this.draftState.tireSize)) {
        this.draftState.tireSize = "";
      }
      const typeOptions = this.getTypeOptions();
      if (this.draftState.typeKey && !typeOptions.some((type) => type.key === this.draftState.typeKey)) {
        this.draftState.typeKey = "";
      }
      const filteredChoices = this.getFilteredChoices();
      if (!this.draftState.choiceId) {
        return;
      }
      if (!filteredChoices.some((choice) => choice.id === this.draftState.choiceId)) {
        this.draftState.choiceId = ((_a = filteredChoices[0]) == null ? void 0 : _a.id) || "";
      }
    }
    syncLegacyStateToAvailable() {
      var _a, _b;
      if (this.state.noneSelected) {
        this.state.tireSize = "";
        this.state.typeKey = "";
        this.state.choiceId = "";
        this.state.modelDeselected = false;
        return;
      }
      const wheelOptions = this.getWheelOptions();
      if (this.state.wheel && !wheelOptions.includes(this.state.wheel)) {
        this.state.wheel = wheelOptions[0] || "";
      }
      const sizeOptions = [
        ...new Set(
          this.choices.filter((choice) => {
            if (this.state.wheel && choice.wheelLabel !== this.state.wheel) return false;
            return true;
          }).map((choice) => choice.tireSize).filter(Boolean)
        )
      ].sort(compareTireSizes);
      if (!sizeOptions.includes(this.state.tireSize)) {
        this.state.tireSize = sizeOptions[0] || "";
      }
      const typeOptions = this.choices.filter((choice) => {
        if (this.state.wheel && choice.wheelLabel !== this.state.wheel) return false;
        if (this.state.tireSize && choice.tireSize !== this.state.tireSize) return false;
        return true;
      }).map((choice) => ({
        key: buildTypeKey(choice.type, choice.typeSub)
      })).filter((item, index, all) => all.findIndex((entry) => entry.key === item.key) === index);
      if (!typeOptions.some((type) => type.key === this.state.typeKey)) {
        this.state.typeKey = ((_a = typeOptions[0]) == null ? void 0 : _a.key) || "";
      }
      const choices = this.choices.filter((choice) => {
        if (this.state.wheel && choice.wheelLabel !== this.state.wheel) return false;
        if (this.state.tireSize && choice.tireSize !== this.state.tireSize) return false;
        if (this.state.typeKey) {
          const key = buildTypeKey(choice.type, choice.typeSub);
          if (key !== this.state.typeKey) return false;
        }
        return true;
      });
      const hasCurrentChoice = choices.some((choice) => choice.id === this.state.choiceId);
      if (!hasCurrentChoice) {
        this.state.choiceId = this.state.modelDeselected ? "" : ((_b = choices[0]) == null ? void 0 : _b.id) || "";
      }
    }
    bindEvents() {
      if (this.__eventsBound) return;
      this.__eventsBound = true;
      if (this.legacyMode) {
        this.__boundHandleClick = (event) => this.handleLegacyClick(event);
        this.addEventListener("click", this.__boundHandleClick);
        return;
      }
      this.__boundHandleClick = (event) => this.handleClick(event);
      this.__boundHandleChange = (event) => this.handleChange(event);
      this.__boundHandleKeydown = (event) => {
        if (event.key === "Escape" && this.isOpen) {
          event.preventDefault();
          this.closeDrawer();
        }
      };
      this.addEventListener("click", this.__boundHandleClick);
      this.addEventListener("change", this.__boundHandleChange);
      document.addEventListener("keydown", this.__boundHandleKeydown);
      this.__directButtonCleanup = [];
      if (this.openTrigger) {
        const onOpenClick = (event) => {
          var _a;
          event.preventDefault();
          debugTireWidget("direct-trigger-click", {
            targetTag: ((_a = event.target) == null ? void 0 : _a.tagName) || ""
          });
          this.openDrawer();
        };
        this.openTrigger.addEventListener("click", onOpenClick);
        this.__directButtonCleanup.push(
          () => this.openTrigger.removeEventListener("click", onOpenClick)
        );
      }
      const closeButtons = Array.from((this.overlayNode || this).querySelectorAll("[data-tw-close]"));
      closeButtons.forEach((button) => {
        const onCloseClick = (event) => {
          event.preventDefault();
          this.closeDrawer();
        };
        button.addEventListener("click", onCloseClick);
        this.__directButtonCleanup.push(() => button.removeEventListener("click", onCloseClick));
      });
      if (this.applyButton) {
        const onApplyClick = (event) => {
          event.preventDefault();
          this.applyDraftSelection();
        };
        this.applyButton.addEventListener("click", onApplyClick);
        this.__directButtonCleanup.push(
          () => this.applyButton.removeEventListener("click", onApplyClick)
        );
      }
      if (this.clearButton) {
        const onClearClick = (event) => {
          event.preventDefault();
          this.clearAppliedSelection();
        };
        this.clearButton.addEventListener("click", onClearClick);
        this.__directButtonCleanup.push(
          () => this.clearButton.removeEventListener("click", onClearClick)
        );
      }
      if (this.overlayNode) {
        const onOverlayClick = (event) => {
          if (event.target === this.overlayNode) {
            this.closeDrawer();
          }
        };
        this.overlayNode.addEventListener("click", onOverlayClick);
        this.__directButtonCleanup.push(
          () => {
            var _a;
            return (_a = this.overlayNode) == null ? void 0 : _a.removeEventListener("click", onOverlayClick);
          }
        );
      }
      if (this.panelNode) {
        const onTouchStart = (event) => {
          var _a, _b;
          if (!this.isMobileDrawerLayout() || !this.isOpen || this.openSelectMenu) return;
          if ((((_a = this.sheetScrollNode) == null ? void 0 : _a.scrollTop) || 0) > 0) return;
          const touch = (_b = event.touches) == null ? void 0 : _b[0];
          if (!touch) return;
          this.__sheetDrag = {
            startY: touch.clientY,
            deltaY: 0,
            dragging: false
          };
          this.panelNode.style.transitionDuration = "0ms";
        };
        const onTouchMove = (event) => {
          var _a, _b;
          const drag = this.__sheetDrag;
          if (!drag || !this.isMobileDrawerLayout() || this.openSelectMenu) return;
          const touch = (_a = event.touches) == null ? void 0 : _a[0];
          if (!touch) return;
          const deltaY = Math.max(0, touch.clientY - drag.startY);
          if (!drag.dragging && deltaY < 6) return;
          if ((((_b = this.sheetScrollNode) == null ? void 0 : _b.scrollTop) || 0) > 0) return;
          drag.dragging = true;
          drag.deltaY = deltaY;
          event.preventDefault();
          this.panelNode.style.transform = `translateY(${deltaY}px)`;
        };
        const onTouchEnd = () => {
          const drag = this.__sheetDrag;
          this.__sheetDrag = null;
          if (!this.panelNode || !this.isMobileDrawerLayout()) return;
          this.panelNode.style.transitionDuration = "";
          if (!drag || !drag.dragging) {
            this.panelNode.style.transform = this.isOpen ? "translateY(0)" : "translateY(calc(100% + 16px))";
            return;
          }
          if (drag.deltaY > 110) {
            this.closeDrawer();
            return;
          }
          this.panelNode.style.transform = "translateY(0)";
        };
        this.panelNode.addEventListener("touchstart", onTouchStart, { passive: true });
        this.panelNode.addEventListener("touchmove", onTouchMove, { passive: false });
        this.panelNode.addEventListener("touchend", onTouchEnd);
        this.panelNode.addEventListener("touchcancel", onTouchEnd);
        this.__directButtonCleanup.push(() => {
          var _a, _b, _c, _d;
          (_a = this.panelNode) == null ? void 0 : _a.removeEventListener("touchstart", onTouchStart);
          (_b = this.panelNode) == null ? void 0 : _b.removeEventListener("touchmove", onTouchMove);
          (_c = this.panelNode) == null ? void 0 : _c.removeEventListener("touchend", onTouchEnd);
          (_d = this.panelNode) == null ? void 0 : _d.removeEventListener("touchcancel", onTouchEnd);
        });
      }
      if (this.previewTrackNode) {
        const onPreviewTrackKeydown = (event) => {
          if (event.key === "ArrowLeft") {
            event.preventDefault();
            this.stepPreviewGallery(-1);
          } else if (event.key === "ArrowRight") {
            event.preventDefault();
            this.stepPreviewGallery(1);
          }
        };
        const onPreviewTrackScroll = () => {
          if (this.__previewScrollFrame) return;
          this.__previewScrollFrame = window.requestAnimationFrame(() => {
            this.__previewScrollFrame = 0;
            this.syncPreviewGalleryIndexFromScroll();
          });
        };
        this.previewTrackNode.addEventListener("keydown", onPreviewTrackKeydown);
        this.previewTrackNode.addEventListener("scroll", onPreviewTrackScroll, { passive: true });
        this.__directButtonCleanup.push(() => {
          var _a, _b;
          (_a = this.previewTrackNode) == null ? void 0 : _a.removeEventListener("keydown", onPreviewTrackKeydown);
          (_b = this.previewTrackNode) == null ? void 0 : _b.removeEventListener("scroll", onPreviewTrackScroll);
          if (this.__previewScrollFrame) {
            window.cancelAnimationFrame(this.__previewScrollFrame);
            this.__previewScrollFrame = 0;
          }
        });
      }
    }
    handleLegacyClick(event) {
      const trigger = event.target.closest("[data-tw-action]");
      if (!trigger) return;
      const action = trigger.getAttribute("data-tw-action");
      if (action === "wheel") {
        this.state.noneSelected = false;
        this.state.wheel = toStr(trigger.getAttribute("data-wheel"));
        this.state.modelDeselected = false;
      } else if (action === "none") {
        this.state.noneSelected = true;
      } else if (action === "size") {
        this.state.noneSelected = false;
        this.state.tireSize = toStr(trigger.getAttribute("data-size"));
        this.state.modelDeselected = false;
      } else if (action === "type") {
        this.state.noneSelected = false;
        this.state.typeKey = toStr(trigger.getAttribute("data-type-key"));
        this.state.modelDeselected = false;
      } else if (action === "choice") {
        this.state.noneSelected = false;
        const choiceId = toStr(trigger.getAttribute("data-choice-id"));
        if (choiceId && this.state.choiceId === choiceId) {
          this.state.choiceId = "";
          this.state.modelDeselected = true;
          this.syncLegacyStateToAvailable();
          this.renderLegacy();
          return;
        }
        this.state.choiceId = choiceId;
        this.state.modelDeselected = false;
        const pickedChoice = this.getChoiceById(choiceId);
        if (pickedChoice) {
          this.state.typeKey = buildTypeKey(pickedChoice.type, pickedChoice.typeSub);
          this.state.tireSize = pickedChoice.tireSize || this.state.tireSize;
          this.state.wheel = pickedChoice.wheelLabel || this.state.wheel;
        }
      }
      this.syncLegacyStateToAvailable();
      this.renderLegacy();
    }
    handleClick(event) {
      var _a;
      const actionButton = event.target.closest("[data-tw-action]");
      if (actionButton) {
        const action = actionButton.getAttribute("data-tw-action");
        if (action === "toggle-wheel-select") {
          this.toggleSelectMenu("wheel");
          return;
        } else if (action === "toggle-size-select") {
          this.toggleSelectMenu("size");
          return;
        } else if (action === "toggle-type-select") {
          this.toggleSelectMenu("type");
          return;
        } else if (action === "clear-size-selection") {
          this.draftState.tireSize = "";
          this.draftState.typeKey = "";
          this.draftState.choiceId = "";
          this.closeSelectMenu();
          this.syncDraftToAvailable();
          this.render();
          return;
        } else if (action === "clear-type-selection") {
          this.draftState.typeKey = "";
          this.draftState.choiceId = "";
          this.closeSelectMenu();
          this.syncDraftToAvailable();
          this.render();
          return;
        } else if (action === "select-size-option") {
          this.draftState.tireSize = toStr(actionButton.getAttribute("data-size"));
          this.draftState.choiceId = "";
          this.closeSelectMenu();
          this.syncDraftToAvailable();
          this.render();
          return;
        } else if (action === "select-type-option") {
          this.draftState.typeKey = toStr(actionButton.getAttribute("data-type-key"));
          this.draftState.choiceId = "";
          this.closeSelectMenu();
          this.syncDraftToAvailable();
          this.render();
          return;
        } else if (action === "preview-prev") {
          this.stepPreviewGallery(-1);
          return;
        } else if (action === "preview-next") {
          this.stepPreviewGallery(1);
          return;
        } else if (action === "preview-thumb" || action === "preview-dot") {
          const choice = this.getDraftChoice();
          const nextIndex = Number(actionButton.getAttribute("data-image-index"));
          const previewImages = this.getPreviewGalleryImages(choice);
          if (!choice || !Number.isInteger(nextIndex) || nextIndex < 0 || nextIndex >= previewImages.length) {
            return;
          }
          this.previewGalleryChoiceId = choice.id;
          this.previewGalleryIndex = nextIndex;
          this.syncPreviewGalleryPosition(true);
          return;
        } else if (action === "wheel") {
          this.draftState.wheel = toStr(actionButton.getAttribute("data-wheel"));
          this.draftState.tireSize = "";
          this.draftState.typeKey = "";
          this.draftState.choiceId = "";
        } else if (action === "choice") {
          const choiceId = toStr(actionButton.getAttribute("data-choice-id"));
          if (choiceId && this.draftState.choiceId === choiceId) {
            this.draftState.choiceId = "";
            if (this.appliedState.choiceId === choiceId) {
              this.appliedState.choiceId = "";
            }
            this.closeSelectMenu();
            this.render();
            return;
          }
          const pickedChoice = this.getChoiceById(choiceId);
          if (pickedChoice) {
            this.draftState.choiceId = pickedChoice.id;
            this.draftState.wheel = pickedChoice.wheelLabel || this.draftState.wheel;
          }
        }
        this.closeSelectMenu();
        this.syncDraftToAvailable();
        this.render();
        return;
      }
      if (this.openSelectMenu) {
        this.closeSelectMenu();
        this.renderWheelOptions();
        this.renderSelects();
      }
      if (event.target.closest("[data-tw-open]")) {
        event.preventDefault();
        debugTireWidget("delegated-open-click", {
          targetTag: ((_a = event.target) == null ? void 0 : _a.tagName) || ""
        });
        this.openDrawer();
        return;
      }
      if (event.target.closest("[data-tw-close]")) {
        event.preventDefault();
        this.closeDrawer();
        return;
      }
      if (event.target.closest("[data-tw-apply]")) {
        event.preventDefault();
        this.applyDraftSelection();
        return;
      }
      if (event.target.closest("[data-tw-clear]")) {
        event.preventDefault();
        this.clearAppliedSelection();
      }
    }
    handleChange(event) {
      const target = event.target;
      if (!target) return;
      if (target === this.sizeSelectNode) {
        this.draftState.tireSize = toStr(target.value);
        this.draftState.choiceId = "";
      } else if (target === this.typeSelectNode) {
        this.draftState.typeKey = toStr(target.value);
        this.draftState.choiceId = "";
      } else {
        return;
      }
      this.syncDraftToAvailable();
      this.render();
    }
    closeSelectMenu() {
      this.openSelectMenu = "";
    }
    toggleSelectMenu(menuName) {
      this.openSelectMenu = this.openSelectMenu === menuName ? "" : menuName;
      this.renderWheelOptions();
      this.renderSelects();
    }
    formatFitmentSummaryLine(line) {
      const raw = toStr(line);
      if (!raw) return "";
      const normalized = normalizeCompactKey(raw);
      if (normalized === "fitsnorubbing") {
        return "Fits - No Rubbing";
      }
      if (normalized.startsWith("withuca")) {
        return "Fits - No Rubbing with UCA";
      }
      if (normalized.startsWith("nouca")) {
        return "Fits - MudFlap Removal & Trimming Likely without UCA";
      }
      return raw.replace(/^fits!\s*/i, "Fits - ").replace(/^fits\s*[:!-]?\s*/i, "Fits - ").replace(/\s+/g, " ").trim();
    }
    getFitmentSummaryLines(choice) {
      const fitment = this.getResolvedFitment(choice);
      return [fitment.title1, fitment.title2].map((line) => this.formatFitmentSummaryLine(line)).filter(Boolean);
    }
    getSizeOptionEntries() {
      return this.getSizeOptions().map((size) => {
        const choice = this.choices.find(
          (item) => (!this.draftState.wheel || item.wheelLabel === this.draftState.wheel) && item.tireSize === size && item.id === this.draftState.choiceId
        ) || this.choices.find(
          (item) => (!this.draftState.wheel || item.wheelLabel === this.draftState.wheel) && item.tireSize === size
        ) || null;
        return {
          value: size,
          label: size,
          fitmentLines: this.getFitmentSummaryLines(choice)
        };
      });
    }
    getTypeOptionEntries() {
      return this.getTypeOptions().map((typeOption) => ({
        value: typeOption.key,
        label: typeOption.display || typeOption.type || "Type"
      }));
    }
    renderCustomDropdown({
      mountNode,
      menuName,
      triggerAction,
      optionAction,
      placeholder,
      options,
      valueAttribute,
      includeFitment = false
    }) {
      if (!mountNode) return;
      const isOpen = this.openSelectMenu === menuName;
      const isDisabled = options.length === 0;
      const shellClasses = [
        "w-full rounded-[8px] border border-[#E2E2E2] bg-white text-left transition",
        isOpen ? "shadow-[0_16px_32px_rgba(15,23,42,0.14)]" : "",
        isDisabled ? "opacity-60" : ""
      ].filter(Boolean).join(" ");
      const triggerClasses = [
        "flex h-[37px] w-[137px] min-w-[137px] items-center justify-between gap-3 rounded-[8px] px-4 text-left transition sm:w-[144px] sm:min-w-[144px]",
        "bg-white hover:bg-[#F5FAFF]"
      ].join(" ");
      const chevronClasses = ["h-5 w-5 rotate-180 text-[#111111] transition-transform", isOpen ? "rotate-0" : ""].join(" ");
      const headerHtml = `<span class="block whitespace-nowrap font-dinpro text-[14px] font-bold leading-[1.5] text-[#111111]">${escapeHtml(placeholder)}</span>`;
      const optionsHtml = options.map((option, index) => {
        const value = option.value;
        const label = option.label;
        const isSelected = menuName === "size" ? value === this.draftState.tireSize : value === this.draftState.typeKey;
        const fitmentLines = includeFitment ? option.fitmentLines || [] : [];
        const itemClasses = [
          "flex w-full flex-col gap-[2px] rounded-[8px] px-3 py-3 text-left transition",
          isSelected ? "bg-[#F5FAFF]" : "hover:bg-[#F5FAFF]"
        ].join(" ");
        return `<div class="${index === 0 ? "" : "mt-[4px] border-t border-[#E2E2E2] pt-[4px]"}">
            <button
              type="button"
              class="${itemClasses}"
              data-tw-action="${optionAction}"
              ${valueAttribute}="${escapeHtml(value)}"
            >
              <div class="font-dinpro text-[14px] font-bold leading-[1.5] text-[#111111]">${escapeHtml(label)}</div>
              ${fitmentLines.length ? `<div class="mt-[2px] space-y-[2px] text-[12px] font-normal leading-[1.5] text-[#1E1E1E]" style="font-family: Inter, sans-serif;">${fitmentLines.map((line) => `<div class="whitespace-pre-line">${escapeHtml(line)}</div>`).join("")}</div>` : ""}
            </button>
          </div>`;
      }).join("");
      mountNode.innerHTML = `<div class="relative ${isOpen ? "z-30" : ""}">
          <div class="${shellClasses}">
            <button
              type="button"
              class="${triggerClasses}"
              data-tw-action="${triggerAction}"
              aria-expanded="${isOpen ? "true" : "false"}"
              aria-disabled="${isDisabled ? "true" : "false"}"
              ${isDisabled ? "disabled" : ""}
            >
              <span class="min-w-0 flex-1">
                ${headerHtml}
              </span>
              <svg class="${chevronClasses}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" aria-hidden="true">
                <path d="M5 12.5L10 7.5L15 12.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
          </div>
          ${isOpen ? `<div class="absolute left-0 right-0 top-[calc(100%-8px)] z-40 rounded-b-[8px] border border-[#E2E2E2] bg-white px-3 pb-3 pt-[11px] shadow-[0_16px_32px_rgba(15,23,42,0.14)]">
                  <div class="max-h-[320px] overflow-y-auto pt-[4px]">
                    ${optionsHtml}
                  </div>
                </div>` : ""}
        </div>`;
    }
    renderSelectionChips() {
      var _a;
      if (!this.selectionChipsNode) return;
      const chips = [];
      if (this.draftState.tireSize) {
        chips.push({
          label: this.draftState.tireSize,
          action: "clear-size-selection",
          ariaLabel: "Clear Tire Size selection"
        });
      }
      const selectedTypeLabel = ((_a = this.getTypeOptions().find((option) => option.key === this.draftState.typeKey)) == null ? void 0 : _a.display) || "";
      if (selectedTypeLabel) {
        chips.push({
          label: selectedTypeLabel,
          action: "clear-type-selection",
          ariaLabel: "Clear Tire Type selection"
        });
      }
      this.selectionChipsNode.innerHTML = chips.map(
        (chip) => `<span class="inline-flex h-[21px] w-fit max-w-full items-center justify-between gap-[4px] rounded-[4px] bg-[#E2E2E2] px-[4px] text-[14px] font-medium leading-[1.5] text-[#111111] md:min-w-[100px]" style="font-family: Inter, sans-serif;">
              <span class="truncate">${escapeHtml(chip.label)}</span>
              <button
                type="button"
                class="inline-flex h-3 w-3 shrink-0 items-center justify-center"
                data-tw-action="${chip.action}"
                aria-label="${chip.ariaLabel}"
              >
                <img
                  src="https://cdn.shopify.com/s/files/1/0559/6944/8111/files/material-symbols-light_close.svg?v=1782071586"
                  alt=""
                  class="h-3 w-3"
                  loading="lazy"
                >
              </button>
            </span>`
      ).join("");
      this.selectionChipsNode.hidden = chips.length === 0;
    }
    openDrawer() {
      var _a, _b;
      if (this.legacyMode || this.isOpen) return;
      this.syncDraftFromApplied();
      this.closeSelectMenu();
      this.isOpen = true;
      (_a = this.openTrigger) == null ? void 0 : _a.setAttribute("aria-expanded", "true");
      this.previouslyFocused = document.activeElement;
      debugTireWidget("openDrawer:start", {
        hasOverlay: Boolean(this.overlayNode),
        hasPanel: Boolean(this.panelNode),
        appliedChoiceId: ((_b = this.appliedState) == null ? void 0 : _b.choiceId) || ""
      });
      if (this.overlayNode) {
        this.overlayNode.hidden = false;
        this.overlayNode.setAttribute("aria-hidden", "false");
        this.applyDrawerVisibility(false);
        window.requestAnimationFrame(() => {
          var _a2, _b2, _c, _d;
          (_a2 = this.overlayNode) == null ? void 0 : _a2.setAttribute("data-open", "true");
          (_b2 = this.panelNode) == null ? void 0 : _b2.setAttribute("data-open", "true");
          this.applyDrawerVisibility(true);
          (_d = (_c = this.panelNode) == null ? void 0 : _c.querySelector("[data-tw-close]")) == null ? void 0 : _d.focus();
        });
      }
      this.lockBodyScroll();
      this.render();
    }
    closeDrawer() {
      var _a, _b, _c, _d;
      this.isOpen = false;
      this.closeSelectMenu();
      (_a = this.openTrigger) == null ? void 0 : _a.setAttribute("aria-expanded", "false");
      debugTireWidget("closeDrawer:start", {
        hasOverlay: Boolean(this.overlayNode),
        hasPanel: Boolean(this.panelNode)
      });
      if (this.overlayNode) {
        this.overlayNode.setAttribute("data-open", "false");
        (_b = this.panelNode) == null ? void 0 : _b.setAttribute("data-open", "false");
        this.overlayNode.setAttribute("aria-hidden", "true");
        this.applyDrawerVisibility(false);
        window.setTimeout(() => {
          if (!this.isOpen && this.overlayNode) {
            this.overlayNode.hidden = true;
          }
        }, 300);
      }
      this.unlockBodyScroll();
      (_d = (_c = this.previouslyFocused) == null ? void 0 : _c.focus) == null ? void 0 : _d.call(_c);
    }
    lockBodyScroll() {
      document.body.classList.add("no-scroll_");
    }
    unlockBodyScroll() {
      document.body.classList.remove("no-scroll_");
    }
    registerAddonBridge() {
      window.TireWidgetAddon = {
        getSelectedCartItems: (mainQuantity = 1) => this.getSelectedCartItems(mainQuantity),
        getSelectedTotalCents: () => this.getSelectedAddonCents(),
        open: () => this.openDrawer(),
        clear: () => this.clearAppliedSelection()
      };
    }
    bindVariantPriceUpdates() {
      if (this.__variantPriceBound) return;
      this.__variantPriceBound = true;
      this.__onVariantChange = () => {
        window.setTimeout(() => this.render(), 60);
      };
      document.addEventListener("variant:change", this.__onVariantChange);
      if (this.form) {
        this.form.addEventListener("change", (event) => {
          const target = event.target;
          if (target && target.name === "id") {
            window.setTimeout(() => this.updateDisplayPrices(), 40);
          }
        });
      }
    }
    getSelectedAddonCents() {
      if (this.legacyMode) {
        const choice2 = this.getChoiceById(this.state.choiceId);
        if (this.state.noneSelected || !choice2 || !choice2.variantId || choice2.quantity <= 0) return 0;
        return (Number(choice2.variantPrice) || 0) * (Number(choice2.quantity) || 1);
      }
      const choice = this.getAppliedChoice();
      if (!choice || !choice.variantId || choice.quantity <= 0) return 0;
      return (Number(choice.variantPrice) || 0) * (Number(choice.quantity) || 1);
    }
    getBaseVariantPriceCents() {
      var _a, _b, _c, _d;
      const mainVariantId = parseNumericId((_b = (_a = this.form) == null ? void 0 : _a.querySelector('input[name="id"]')) == null ? void 0 : _b.value) || 0;
      const mapped = mainVariantId ? (_d = (_c = window.VARIANT_PRICE_MAP) == null ? void 0 : _c[String(mainVariantId)]) == null ? void 0 : _d.price : null;
      const mappedCents = parseCents(mapped);
      if (mapped != null && mappedCents > 0) {
        return mappedCents;
      }
      const mainPriceEl = document.querySelector(".regular-price.price-item--regular");
      if (!mainPriceEl) return 0;
      const raw = toStr(mainPriceEl.textContent).replace(/[^0-9.]/g, "");
      const parsed = Math.round(parseFloat(raw || "0") * 100);
      return Number.isFinite(parsed) ? parsed : 0;
    }
    updateDisplayPrices() {
      if (window.MudifyAddonPriceSync && typeof window.MudifyAddonPriceSync.applyCombinedPrice === "function") {
        window.MudifyAddonPriceSync.applyCombinedPrice();
        return;
      }
      const base = this.getBaseVariantPriceCents();
      const addon = this.getSelectedAddonCents();
      const total = base + addon;
      const formatted = formatMoney(total);
      const mainPriceEl = document.querySelector(".regular-price.price-item--regular");
      if (mainPriceEl) {
        mainPriceEl.textContent = formatted;
      }
      const stickyPriceEl = document.querySelector(".sticky-add-to-cart .product-price");
      if (stickyPriceEl) {
        stickyPriceEl.textContent = formatted;
      }
    }
    buildSelectedTireItem(mainQuantity = 1) {
      var _a, _b, _c, _d;
      if (this.legacyMode) {
        const choice2 = this.getChoiceById(this.state.choiceId);
        if (!choice2 || this.state.noneSelected || !choice2.variantId || choice2.quantity <= 0) return null;
        const mainVariantId2 = parseNumericId((_b = (_a = this.form) == null ? void 0 : _a.querySelector('input[name="id"]')) == null ? void 0 : _b.value) || 0;
        if (mainVariantId2 && mainVariantId2 === choice2.variantId) return null;
        const tireLabel2 = String(
          choice2.model || choice2.variantTitle || choice2.productTitle || choice2.rawTireSize || ""
        );
        const baseQty2 = Math.max(1, Number(choice2.quantity) || 1);
        const mainQty2 = Math.max(1, Number(mainQuantity) || 1);
        const fitment2 = this.getResolvedFitment(choice2);
        return {
          id: choice2.variantId,
          quantity: baseQty2 * mainQty2,
          properties: {
            _source: "tire_widget",
            _linked_product: window.location.pathname,
            _tire_choice_id: String(choice2.id || ""),
            _tire_choice_label: tireLabel2,
            _tire_size: String(choice2.tireSize || ""),
            _tire_type: String(choice2.type || ""),
            _tire_type_sub: String(choice2.typeSub || ""),
            _tire_fitment_title_1: String(fitment2.title1 || ""),
            _tire_fitment_title_2: String(fitment2.title2 || ""),
            _tire_fitment_note: String(fitment2.note || ""),
            _tire_variant_sku: String(choice2.variantSku || ""),
            _tire_product_id: choice2.productId ? String(choice2.productId) : "",
            _tire_product_handle: String(choice2.productHandle || ""),
            _tire_product_title: String(choice2.productTitle || ""),
            _tire_set_quantity: String(choice2.quantity || "")
          }
        };
      }
      const choice = this.getAppliedChoice();
      if (!choice || !choice.variantId || choice.quantity <= 0) return null;
      const mainVariantId = parseNumericId((_d = (_c = this.form) == null ? void 0 : _c.querySelector('input[name="id"]')) == null ? void 0 : _d.value) || 0;
      if (mainVariantId && mainVariantId === choice.variantId) return null;
      const tireLabel = String(
        choice.model || choice.variantTitle || choice.productTitle || choice.rawTireSize || ""
      );
      const baseQty = Math.max(1, Number(choice.quantity) || 1);
      const mainQty = Math.max(1, Number(mainQuantity) || 1);
      const fitment = this.getResolvedFitment(choice);
      return {
        id: choice.variantId,
        quantity: baseQty * mainQty,
        properties: {
          _source: "tire_widget",
          _linked_product: window.location.pathname,
          _tire_choice_id: String(choice.id || ""),
          _tire_choice_label: tireLabel,
          _tire_size: String(choice.tireSize || ""),
          _tire_type: String(choice.type || ""),
          _tire_type_sub: String(choice.typeSub || ""),
          _tire_fitment_title_1: String(fitment.title1 || ""),
          _tire_fitment_title_2: String(fitment.title2 || ""),
          _tire_fitment_note: String(fitment.note || ""),
          _tire_variant_sku: String(choice.variantSku || ""),
          _tire_product_id: choice.productId ? String(choice.productId) : "",
          _tire_product_handle: String(choice.productHandle || ""),
          _tire_product_title: String(choice.productTitle || ""),
          _tire_set_quantity: String(choice.quantity || "")
        }
      };
    }
    getSelectedCartItems(mainQuantity = 1) {
      const item = this.buildSelectedTireItem(mainQuantity);
      return item ? [item] : [];
    }
    getCurrentLiftHeight() {
      var _a;
      const liveLiftHeight = parseLiftHeight(getLiftSelectionText());
      if (liveLiftHeight != null) return liveLiftHeight;
      return parseLiftHeight((_a = this.data) == null ? void 0 : _a.initialLiftSelection);
    }
    getResolvedFitment(choice) {
      const fallback = {
        title1: toStr(choice == null ? void 0 : choice.fitmentTitle1),
        title2: toStr(choice == null ? void 0 : choice.fitmentTitle2),
        note: toStr(choice == null ? void 0 : choice.fitmentNote),
        reference: ""
      };
      const rules = choice == null ? void 0 : choice.fitmentRules;
      if (!rules || typeof rules !== "object") {
        return fallback;
      }
      const liftHeight = this.getCurrentLiftHeight();
      if (liftHeight == null) {
        return fallback;
      }
      let reference = "";
      if (liftHeight <= this.fitmentRanges.lte1_5Max) {
        reference = toStr(rules.lte1_5);
      } else if (liftHeight >= this.fitmentRanges.gte2_5Min) {
        reference = toStr(rules.gte2_5);
      } else {
        reference = toStr(rules.between2);
      }
      const resolved = resolveFitmentReference(reference);
      return {
        title1: resolved.title1 || fallback.title1,
        title2: resolved.title2 || fallback.title2,
        note: resolved.note || fallback.note,
        reference
      };
    }
    getLowestPricedChoice() {
      return this.choices.reduce((lowest, choice) => {
        if (!lowest) return choice;
        if (choice.variantPrice <= 0) return lowest;
        if (lowest.variantPrice <= 0 || choice.variantPrice < lowest.variantPrice) return choice;
        return lowest;
      }, null);
    }
    getMaxSavingsCents() {
      return this.choices.reduce((max, choice) => {
        const compareAtSavings = Math.max(
          0,
          (choice.variantCompareAtPrice || 0) - (choice.variantPrice || 0)
        );
        const badgeSavings = parseBadgeSavingsCents(choice.discountBadge || choice.tireBadge);
        const savings = Math.max(compareAtSavings, badgeSavings);
        return Math.max(max, savings);
      }, 0);
    }
    getChoiceImage(choice) {
      var _a;
      return toStr(choice == null ? void 0 : choice.variantImage) || toStr((_a = choice == null ? void 0 : choice.galleryImages) == null ? void 0 : _a[0]);
    }
    getCardImage(choice) {
      var _a;
      return toStr((_a = this.data) == null ? void 0 : _a.cardImageOverride) || this.getChoiceImage(choice);
    }
    getPreviewGalleryImages(choice) {
      const galleryImages = Array.isArray(choice == null ? void 0 : choice.galleryImages) ? choice.galleryImages : [];
      const normalized = galleryImages.map((image) => toStr(image)).filter(Boolean);
      if (!normalized.length && (choice == null ? void 0 : choice.variantImage)) {
        normalized.push(toStr(choice.variantImage));
      }
      return [...new Set(normalized)];
    }
    getPreviewGalleryState(choice) {
      const previewImages = this.getPreviewGalleryImages(choice);
      const choiceId = toStr(choice == null ? void 0 : choice.id);
      if (this.previewGalleryChoiceId !== choiceId) {
        this.previewGalleryChoiceId = choiceId;
        this.previewGalleryIndex = 0;
      }
      if (!Number.isInteger(this.previewGalleryIndex) || this.previewGalleryIndex < 0) {
        this.previewGalleryIndex = 0;
      }
      if (this.previewGalleryIndex >= previewImages.length) {
        this.previewGalleryIndex = Math.max(0, previewImages.length - 1);
      }
      return {
        choiceId,
        images: previewImages,
        activeIndex: this.previewGalleryIndex || 0,
        signature: `${choiceId}::${previewImages.join("|")}`
      };
    }
    renderPreviewSlides(choice, previewImages) {
      if (!this.previewTrackNode) return;
      this.previewTrackNode.hidden = previewImages.length === 0;
      this.previewTrackNode.innerHTML = previewImages.map(
        (image, index) => `<figure
            class="pmg-slide h-[320px] w-full shrink-0 snap-center"
            data-image-index="${index}"
          >
            <img
              src="${escapeHtml(image)}"
              alt="${escapeHtml((choice == null ? void 0 : choice.model) || (choice == null ? void 0 : choice.productTitle) || "Tire preview")}"
              class="block h-full w-full object-contain object-center"
              loading="${index === 0 ? "eager" : "lazy"}"
            >
          </figure>`
      ).join("");
    }
    renderPreviewThumbnails(choice, previewImages) {
      if (!this.previewThumbsNode) return;
      this.previewThumbsNode.innerHTML = "";
      this.previewThumbsNode.hidden = true;
    }
    renderPreviewDots(previewImages) {
      if (!this.previewDotsNode) return;
      this.previewDotsNode.innerHTML = "";
      this.previewDotsNode.hidden = previewImages.length < 2;
      if (previewImages.length < 2) {
        return;
      }
      previewImages.forEach((_, index) => {
        this.previewDotsNode.insertAdjacentHTML(
          "beforeend",
          `<button
            type="button"
            class="pmg-dot h-[6px] w-[6px] rounded-full border border-neutral-400 bg-neutral-400 transition-all aria-[selected=true]:border-[#111111] aria-[selected=true]:bg-[#111111]"
            data-tw-action="preview-dot"
            data-image-index="${index}"
            aria-selected="false"
            aria-label="Go to slide ${index + 1}"
          ></button>`
        );
      });
    }
    syncPreviewGalleryControls(activeIndex, totalSlides) {
      const thumbButtons = this.previewThumbsNode ? Array.from(this.previewThumbsNode.querySelectorAll('[data-tw-action="preview-thumb"]')) : [];
      const dotButtons = this.previewDotsNode ? Array.from(this.previewDotsNode.querySelectorAll('[data-tw-action="preview-dot"]')) : [];
      thumbButtons.forEach((button, index) => {
        button.setAttribute("aria-selected", index === activeIndex ? "true" : "false");
      });
      dotButtons.forEach((button, index) => {
        button.setAttribute("aria-selected", index === activeIndex ? "true" : "false");
      });
      if (this.previewPrevButton) {
        this.previewPrevButton.disabled = totalSlides < 2 || activeIndex <= 0;
        this.previewPrevButton.hidden = totalSlides < 2;
      }
      if (this.previewNextButton) {
        this.previewNextButton.disabled = totalSlides < 2 || activeIndex >= totalSlides - 1;
        this.previewNextButton.hidden = totalSlides < 2;
      }
      if (this.previewLiveNode) {
        this.previewLiveNode.textContent = totalSlides > 0 ? `Media ${activeIndex + 1} of ${totalSlides}` : "";
      }
    }
    snapPreviewGalleryTo(activeIndex, smooth = true) {
      if (!this.previewTrackNode) return;
      const slides = Array.from(this.previewTrackNode.querySelectorAll(".pmg-slide"));
      const slide = slides[activeIndex];
      if (!slide) return;
      const trackRect = this.previewTrackNode.getBoundingClientRect();
      const slideRect = slide.getBoundingClientRect();
      const left = this.previewTrackNode.scrollLeft + (slideRect.left - trackRect.left);
      this.previewTrackNode.scrollTo({ left, behavior: smooth ? "smooth" : "auto" });
      this.syncPreviewGalleryControls(activeIndex, slides.length);
    }
    syncPreviewGalleryPosition(smooth = true) {
      const choice = this.getDraftChoice();
      if (!choice) return;
      const { activeIndex, images } = this.getPreviewGalleryState(choice);
      this.snapPreviewGalleryTo(activeIndex, smooth);
      this.syncPreviewGalleryControls(activeIndex, images.length);
    }
    stepPreviewGallery(direction) {
      const choice = this.getDraftChoice();
      if (!choice) return;
      const { images, activeIndex } = this.getPreviewGalleryState(choice);
      if (images.length < 2) return;
      const nextIndex = Math.max(0, Math.min(images.length - 1, activeIndex + direction));
      if (nextIndex === activeIndex) return;
      this.previewGalleryIndex = nextIndex;
      this.syncPreviewGalleryPosition(true);
    }
    syncPreviewGalleryIndexFromScroll() {
      if (!this.previewTrackNode) return;
      const slides = Array.from(this.previewTrackNode.querySelectorAll(".pmg-slide"));
      if (!slides.length) return;
      const mid = this.previewTrackNode.scrollLeft + this.previewTrackNode.clientWidth / 2;
      const trackRect = this.previewTrackNode.getBoundingClientRect();
      let nearest = 0;
      let best = Infinity;
      for (let index = 0; index < slides.length; index += 1) {
        const slideRect = slides[index].getBoundingClientRect();
        const left = this.previewTrackNode.scrollLeft + (slideRect.left - trackRect.left);
        const center = left + slideRect.width / 2;
        const distance = Math.abs(center - mid);
        if (distance < best) {
          best = distance;
          nearest = index;
        }
      }
      if (nearest !== this.previewGalleryIndex) {
        this.previewGalleryIndex = nearest;
        this.syncPreviewGalleryControls(nearest, slides.length);
      }
    }
    getCardPreviewChoice() {
      const choiceWithImage = this.choices.find((choice) => Boolean(this.getChoiceImage(choice))) || null;
      return choiceWithImage || this.getLowestPricedChoice() || this.choices[0] || null;
    }
    isDraftSameAsApplied() {
      return toStr(this.draftState.choiceId) === toStr(this.appliedState.choiceId);
    }
    applyDraftSelection() {
      if (this.legacyMode) return;
      if (!this.draftState.choiceId) {
        return;
      }
      this.appliedState.choiceId = this.draftState.choiceId;
      this.closeDrawer();
      this.render();
    }
    clearAppliedSelection() {
      if (this.legacyMode) {
        this.state.choiceId = "";
        this.state.modelDeselected = true;
        this.state.noneSelected = false;
        this.syncLegacyStateToAvailable();
        this.renderLegacy();
        return;
      }
      this.appliedState.choiceId = "";
      this.draftState = this.getDefaultDraftState();
      this.closeDrawer();
      this.render();
    }
    renderCard() {
      const appliedChoice = this.getAppliedChoice();
      const previewChoice = appliedChoice || this.getCardPreviewChoice();
      const maxSavings = this.getMaxSavingsCents();
      if (this.openTrigger) {
        this.openTrigger.classList.toggle("is-selected", Boolean(appliedChoice));
      }
      if (this.cardHeadingNode) {
        this.cardHeadingNode.textContent = appliedChoice ? "Tires Added" : "Add Tires";
      }
      if (this.cardSubtitleNode) {
        this.cardSubtitleNode.textContent = appliedChoice ? appliedChoice.model || appliedChoice.productTitle || "Selected tire" : "Set of 4";
      }
      if (this.cardMetaNode) {
        const metaText = appliedChoice ? [appliedChoice.tireSize, appliedChoice.type || appliedChoice.typeDisplay].filter(Boolean).join("  •  ") : "";
        this.cardMetaNode.textContent = metaText;
        this.cardMetaNode.hidden = !metaText;
      }
      if (this.cardPriceNode) {
        if (appliedChoice) {
          this.cardPriceNode.textContent = formatMoney(appliedChoice.variantPrice);
        } else if (previewChoice) {
          this.cardPriceNode.textContent = `From ${formatMoney(previewChoice.variantPrice)}`;
        } else {
          this.cardPriceNode.textContent = "";
        }
      }
      if (this.cardSaveNode) {
        this.cardSaveNode.textContent = maxSavings > 0 ? `SAVE UP TO ${formatMoney(maxSavings)}` : "";
        this.cardSaveNode.hidden = maxSavings <= 0;
      }
      if (this.sectionCopyLabelNode) {
        this.sectionCopyLabelNode.textContent = "Add Tires to your kit";
      }
      if (this.sectionCopySaveNode) {
        this.sectionCopySaveNode.textContent = "";
        this.sectionCopySaveNode.hidden = true;
      }
      if (this.cardImageNode) {
        const imageSource = this.getCardImage(previewChoice);
        const imageAlt = (appliedChoice == null ? void 0 : appliedChoice.model) || (previewChoice == null ? void 0 : previewChoice.model) || "Tire option";
        this.cardImageNode.hidden = !imageSource;
        if (imageSource) {
          this.cardImageNode.src = imageSource;
          this.cardImageNode.alt = imageAlt;
        } else {
          this.cardImageNode.removeAttribute("src");
          this.cardImageNode.alt = "";
        }
      }
      if (this.cardImageFallbackNode) {
        this.cardImageFallbackNode.hidden = Boolean(this.getCardImage(previewChoice));
      }
    }
    renderWheelOptions() {
      if (!this.wheelNode) return;
      const wheelOptions = this.getWheelOptions();
      const isOpen = this.openSelectMenu === "wheel";
      this.wheelNode.innerHTML = isOpen ? `<div class="border-b border-[#E2E2E2] bg-[#F2F2F2] pb-3">
            <div class="grid grid-cols-3 gap-2 md:pt-4">
            ${wheelOptions.map((wheel) => {
        const isActive = wheel === this.draftState.wheel;
        const classes = [
          "flex h-14 w-full items-center justify-center rounded-[8px] border px-4 text-center font-dinpro text-[16px] font-bold leading-none transition",
          isActive ? "border-[#1654A3] bg-[#F4FAFF] text-[#111111]" : "border-[#d4d7dd] bg-white text-[#111111] hover:border-[#1654A3] hover:bg-[#F4FAFF]"
        ].join(" ");
        return `<button
                  type="button"
                  class="${classes}"
                  data-tw-action="wheel"
                  data-wheel="${escapeHtml(wheel)}"
                >
                  ${escapeHtml(wheel)}
                </button>`;
      }).join("")}
            </div>
          </div>` : "";
      if (this.wheelCurrentNode) {
        this.wheelCurrentNode.textContent = this.draftState.wheel || (wheelOptions[0] || "");
      }
      if (this.wheelBadgeNode) {
        this.wheelBadgeNode.textContent = String(wheelOptions.length || 0);
      }
      if (this.wheelHeaderNode) {
        this.wheelHeaderNode.setAttribute("aria-expanded", isOpen ? "true" : "false");
        this.wheelHeaderNode.classList.toggle("border-b", !isOpen);
      }
      if (this.wheelChevronNode) {
        this.wheelChevronNode.classList.toggle("rotate-180", isOpen);
      }
    }
    renderSelects() {
      const sizeOptions = this.getSizeOptions();
      const typeOptions = this.getTypeOptions();
      const sizeOptionEntries = this.getSizeOptionEntries();
      const typeOptionEntries = this.getTypeOptionEntries();
      if (this.sizeSelectNode) {
        const options = [
          '<option value="">Tire Size</option>',
          ...sizeOptions.map(
            (size) => `<option value="${escapeHtml(size)}"${size === this.draftState.tireSize ? " selected" : ""}>${escapeHtml(size)}</option>`
          )
        ];
        this.sizeSelectNode.innerHTML = options.join("");
      }
      if (this.typeSelectNode) {
        const options = [
          '<option value="">Tire Type</option>',
          ...typeOptions.map(
            (typeOption) => `<option value="${escapeHtml(typeOption.key)}"${typeOption.key === this.draftState.typeKey ? " selected" : ""}>${escapeHtml(typeOption.display || typeOption.type || "Type")}</option>`
          )
        ];
        this.typeSelectNode.innerHTML = options.join("");
      }
      this.renderCustomDropdown({
        mountNode: this.sizeDropdownNode,
        menuName: "size",
        triggerAction: "toggle-size-select",
        optionAction: "select-size-option",
        placeholder: "Tire Size",
        options: sizeOptionEntries,
        valueAttribute: "data-size",
        includeFitment: true
      });
      this.renderCustomDropdown({
        mountNode: this.typeDropdownNode,
        menuName: "type",
        triggerAction: "toggle-type-select",
        optionAction: "select-type-option",
        placeholder: "Tire Type",
        options: typeOptionEntries,
        valueAttribute: "data-type-key"
      });
      this.renderSelectionChips();
    }
    renderModelGrid() {
      if (!this.modelNode) return;
      const filteredChoices = this.getFilteredChoices();
      this.modelNode.innerHTML = "";
      filteredChoices.forEach((choice) => {
        const isActive = choice.id === this.draftState.choiceId;
        const badgeText = this.isLiftKitHost ? "" : choice.discountBadge || choice.tireBadge;
        const showCompareAt = choice.variantCompareAtPrice > choice.variantPrice;
        const typeLabel = choice.type || choice.typeDisplay || formatTypeSubDisplay(choice.typeSub) || "";
        const displayTitle = formatChoiceDisplayTitle(choice.model || "") || choice.productTitle || choice.variantTitle || "Tire option";
        const cardClasses = [
          "group flex cursor-pointer flex-col overflow-hidden rounded-[8px] border text-left transition",
          isActive ? "border-[#1654A3] bg-[#F4FAFF]" : "border-[#e5e7eb] bg-white hover:border-[#1654A3] hover:bg-[#F4FAFF]"
        ].join(" ");
        const imageHtml = choice.variantImage ? `<div class="relative h-[7.5rem] shrink-0 overflow-hidden bg-[#f4f5f7]">
              ${badgeText ? `<span class="absolute left-2 top-2 z-[1] rounded-[4px] bg-[#ffc928] px-2 py-1 font-dinpro text-[10px] font-bold uppercase leading-none text-[#111111]">${escapeHtml(badgeText)}</span>` : ""}
              <img src="${escapeHtml(choice.variantImage)}" alt="${escapeHtml(displayTitle)}" class="block h-full w-full object-cover object-center">
            </div>` : `<div class="relative h-[7.5rem] shrink-0 bg-[#f4f5f7]">${badgeText ? `<span class="absolute left-2 top-2 z-[1] rounded-[4px] bg-[#ffc928] px-2 py-1 font-dinpro text-[10px] font-bold uppercase leading-none text-[#111111]">${escapeHtml(badgeText)}</span>` : ""}</div>`;
        this.modelNode.insertAdjacentHTML(
          "beforeend",
          `<button type="button" class="${cardClasses}" data-tw-action="choice" data-choice-id="${escapeHtml(choice.id)}">
            ${imageHtml}
            <span class="flex flex-1 flex-col justify-between px-2 pb-2 pt-2">
              <span class="block text-[14px] font-bold leading-[1.5] text-[#111111] sm:text-[16px] sm:leading-[1.4] font-dinpro">${escapeHtml(displayTitle)}</span>
              <span class="mt-3 flex flex-wrap items-end gap-x-2 gap-y-1">
                ${showCompareAt ? `<span class="font-dinpro text-[14px] font-normal leading-[1.5] text-[#86868B] line-through">${escapeHtml(formatMoney(choice.variantCompareAtPrice))}</span>` : ""}
                <span class="font-dinpro text-[14px] font-normal leading-[1.5] text-[#000000] sm:text-[16px] sm:font-medium">${escapeHtml(formatMoney(choice.variantPrice))}</span>
              </span>
              <span class="mt-3 flex flex-wrap gap-2">
                ${choice.tireSize ? `<span class="rounded-[4px] bg-[#F2F2F2] px-2 py-1 font-dinpro text-[12px] italic leading-[1.5] text-[#4b5563]">${escapeHtml(choice.tireSize)}</span>` : ""}
                ${typeLabel ? `<span class="rounded-[4px] bg-[#F2F2F2] px-2 py-1 font-dinpro text-[12px] italic leading-[1.5] text-[#4b5563]">${escapeHtml(typeLabel)}</span>` : ""}
              </span>
            </span>
          </button>`
        );
      });
      if (this.emptyNode) {
        this.emptyNode.hidden = filteredChoices.length > 0;
      }
      if (this.productCountNode) {
        this.productCountNode.textContent = String(filteredChoices.length || 0);
      }
    }
    renderPreviewPanel() {
      if (!this.previewPanelNode) return;
      const choice = this.getDraftChoice();
      if (!choice) {
        this.previewPanelNode.hidden = true;
        this.previewPanelNode.classList.add("hidden");
        if (this.fitmentNode) this.fitmentNode.hidden = true;
        return;
      }
      this.previewPanelNode.hidden = false;
      this.previewPanelNode.classList.remove("hidden");
      const { images: previewImages, activeIndex, signature } = this.getPreviewGalleryState(choice);
      if (this.previewGallerySignature !== signature) {
        this.previewGallerySignature = signature;
        this.renderPreviewSlides(choice, previewImages);
        this.renderPreviewThumbnails(choice, previewImages);
        this.renderPreviewDots(previewImages);
      }
      this.snapPreviewGalleryTo(activeIndex, false);
      if (this.previewTitleNode) {
        this.previewTitleNode.textContent = choice.model || choice.productTitle || "Tire option";
      }
      if (this.previewBadgeNode) {
        const badgeText = this.isLiftKitHost ? "" : choice.discountBadge || choice.tireBadge;
        this.previewBadgeNode.textContent = badgeText;
        this.previewBadgeNode.hidden = !badgeText;
        this.previewBadgeNode.classList.toggle("hidden", !badgeText);
      }
      if (this.previewCompareAtNode) {
        const showCompareAt = choice.variantCompareAtPrice > choice.variantPrice;
        this.previewCompareAtNode.textContent = showCompareAt ? formatMoney(choice.variantCompareAtPrice) : "";
        this.previewCompareAtNode.hidden = !showCompareAt;
      }
      if (this.previewPriceNode) {
        this.previewPriceNode.textContent = formatMoney(choice.variantPrice);
      }
      if (this.previewSaveNode) {
        const savings = Math.max(0, (choice.variantCompareAtPrice || 0) - (choice.variantPrice || 0));
        this.previewSaveNode.textContent = savings > 0 ? `SAVE ${formatMoney(savings)}` : "";
        this.previewSaveNode.hidden = savings <= 0;
      }
      if (this.previewSizeNode) {
        this.previewSizeNode.textContent = choice.tireSize || "";
        this.previewSizeNode.hidden = !choice.tireSize;
      }
      if (this.previewTypeNode) {
        const typeLabel = choice.type || choice.typeDisplay || "";
        this.previewTypeNode.textContent = typeLabel;
        this.previewTypeNode.hidden = !typeLabel;
      }
      if (this.previewDescriptionNode) {
        this.previewDescriptionNode.innerHTML = choice.productDescription || "";
      }
      if (this.previewDescriptionSectionNode) {
        const hasDescription = Boolean(toStr(choice.productDescription));
        this.previewDescriptionSectionNode.hidden = !hasDescription;
      }
      const fitment = this.getResolvedFitment(choice);
      const fitmentTitle1 = fitment.title1;
      const fitmentTitle2 = fitment.title2;
      const fitmentNote = fitment.note;
      if (this.fitmentTitle1Node) {
        this.fitmentTitle1Node.textContent = fitmentTitle1;
        this.fitmentTitle1Node.hidden = !fitmentTitle1;
      }
      if (this.fitmentTitle2Node) {
        this.fitmentTitle2Node.textContent = fitmentTitle2;
        this.fitmentTitle2Node.hidden = !fitmentTitle2;
      }
      if (this.fitmentNoteNode) {
        this.fitmentNoteNode.textContent = fitmentNote;
        this.fitmentNoteNode.hidden = !fitmentNote;
      }
      if (this.fitmentNode) {
        this.fitmentNode.hidden = !fitmentTitle1 && !fitmentTitle2 && !fitmentNote;
      }
    }
    renderFooter() {
      const hasDraftSelection = Boolean(this.draftState.choiceId);
      if (this.applyButton) {
        let label = "SELECT OPTIONS BEFORE ADDING TO CART";
        let isDisabled = true;
        if (hasDraftSelection) {
          if (this.isDraftSameAsApplied()) {
            label = "Keep tires in your kit";
          } else {
            label = "Add tires to your kit";
          }
          isDisabled = false;
        }
        this.applyButton.textContent = label;
        this.applyButton.disabled = isDisabled;
      }
      if (this.clearButton) {
        this.clearButton.hidden = true;
        this.clearButton.classList.add("hidden");
      }
    }
    updateProperties() {
      if (this.legacyMode) {
        const choice2 = this.getChoiceById(this.state.choiceId);
        const wheel = this.state.noneSelected ? "NONE" : this.state.wheel;
        const fitment2 = this.getResolvedFitment(choice2);
        if (this.propConfig) this.propConfig.value = toStr(this.data.title);
        if (this.propWheel) this.propWheel.value = wheel || "";
        if (this.propSize) {
          this.propSize.value = this.state.noneSelected ? "NONE" : (choice2 == null ? void 0 : choice2.tireSize) || "";
        }
        if (this.propType) this.propType.value = this.state.noneSelected ? "" : (choice2 == null ? void 0 : choice2.type) || "";
        if (this.propModel) {
          this.propModel.value = this.state.noneSelected ? "NONE" : (choice2 == null ? void 0 : choice2.model) || (choice2 == null ? void 0 : choice2.productTitle) || "";
        }
        if (this.propFitment1) {
          this.propFitment1.value = this.state.noneSelected ? "" : fitment2.title1 || "";
        }
        if (this.propFitment2) {
          this.propFitment2.value = this.state.noneSelected ? "" : fitment2.title2 || "";
        }
        if (this.propFitmentNote) {
          this.propFitmentNote.value = this.state.noneSelected ? "" : fitment2.note || "";
        }
        if (this.propVariantId) {
          this.propVariantId.value = this.state.noneSelected ? "" : String((choice2 == null ? void 0 : choice2.variantId) || "");
        }
        if (this.propVariantSku) {
          this.propVariantSku.value = this.state.noneSelected ? "" : String((choice2 == null ? void 0 : choice2.variantSku) || "");
        }
        if (this.propProductId) {
          this.propProductId.value = this.state.noneSelected ? "" : String((choice2 == null ? void 0 : choice2.productId) || "");
        }
        if (this.propProductHandle) {
          this.propProductHandle.value = this.state.noneSelected ? "" : String((choice2 == null ? void 0 : choice2.productHandle) || "");
        }
        if (this.propProductTitle) {
          this.propProductTitle.value = this.state.noneSelected ? "" : String((choice2 == null ? void 0 : choice2.productTitle) || "");
        }
        if (this.propQty) {
          this.propQty.value = this.state.noneSelected ? "" : String((choice2 == null ? void 0 : choice2.quantity) || "");
        }
        return;
      }
      const choice = this.getAppliedChoice();
      const fitment = this.getResolvedFitment(choice);
      if (this.propConfig) this.propConfig.value = toStr(this.data.title);
      if (this.propWheel) this.propWheel.value = (choice == null ? void 0 : choice.wheelLabel) || "";
      if (this.propSize) this.propSize.value = (choice == null ? void 0 : choice.tireSize) || "";
      if (this.propType) this.propType.value = (choice == null ? void 0 : choice.type) || "";
      if (this.propModel) this.propModel.value = (choice == null ? void 0 : choice.model) || (choice == null ? void 0 : choice.productTitle) || "";
      if (this.propFitment1) this.propFitment1.value = choice ? fitment.title1 || "" : "";
      if (this.propFitment2) this.propFitment2.value = choice ? fitment.title2 || "" : "";
      if (this.propFitmentNote) this.propFitmentNote.value = choice ? fitment.note || "" : "";
      if (this.propVariantId) this.propVariantId.value = choice ? String(choice.variantId || "") : "";
      if (this.propVariantSku) this.propVariantSku.value = choice ? String(choice.variantSku || "") : "";
      if (this.propProductId) this.propProductId.value = choice ? String(choice.productId || "") : "";
      if (this.propProductHandle) {
        this.propProductHandle.value = choice ? String(choice.productHandle || "") : "";
      }
      if (this.propProductTitle) {
        this.propProductTitle.value = choice ? String(choice.productTitle || "") : "";
      }
      if (this.propQty) this.propQty.value = choice ? String(choice.quantity || "") : "";
    }
    emitWidgetChange() {
      const detail = {
        addonCents: this.getSelectedAddonCents(),
        selectedChoiceId: this.legacyMode ? this.state.choiceId || "" : this.appliedState.choiceId || "",
        noneSelected: this.legacyMode ? this.state.noneSelected : false
      };
      const signature = JSON.stringify(detail);
      if (signature === this.lastEmittedSignature) return;
      this.lastEmittedSignature = signature;
      this.dispatchEvent(
        new CustomEvent("tire-widget:change", {
          bubbles: true,
          detail
        })
      );
    }
    render() {
      if (this.legacyMode) {
        this.renderLegacy();
        return;
      }
      if (this.titleNode) {
        this.titleNode.textContent = "Shop Tires - Set of 4";
      }
      this.renderCard();
      this.renderWheelOptions();
      this.renderSelects();
      this.renderMobileFitmentSection();
      this.renderModelGrid();
      this.updateDrawerFilterFocusState();
      this.renderPreviewPanel();
      this.renderFooter();
      this.updateProperties();
      this.updateDisplayPrices();
      this.emitWidgetChange();
    }
    renderLegacy() {
      if (this.titleNode) {
        this.titleNode.textContent = toStr(this.data.title) || "Shop Tires - Set of 4";
      }
      const hideDependentSteps = this.state.noneSelected;
      if (this.stepSizeNode) this.stepSizeNode.hidden = hideDependentSteps;
      if (this.stepTypeNode) this.stepTypeNode.hidden = hideDependentSteps;
      if (this.stepModelNode) this.stepModelNode.hidden = hideDependentSteps;
      const wheelOptions = this.getWheelOptions();
      if (this.wheelNode) {
        this.wheelNode.innerHTML = "";
        wheelOptions.forEach((wheel) => {
          const isActive = wheel === this.state.wheel && !this.state.noneSelected;
          const classes = [
            "cursor-pointer rounded-[4px] border px-[15px] py-[13px] font-dinmedium text-[12px] font-medium uppercase leading-none tracking-tight transition-colors duration-150",
            isActive ? "border-[#575757] bg-[#575757] text-white" : "border-[#a9a9a9] bg-white text-[#595959] hover:border-[#575757] hover:bg-[#575757] hover:text-white"
          ].join(" ");
          this.wheelNode.insertAdjacentHTML(
            "beforeend",
            `<button type="button" class="${classes}" data-tw-action="wheel" data-wheel="${escapeHtml(wheel)}">${escapeHtml(wheel)}</button>`
          );
        });
        if (this.data.showNone) {
          const noneClasses = [
            "cursor-pointer rounded-[4px] border px-[15px] py-[13px] font-dinmedium text-[12px] font-medium uppercase leading-none tracking-tight transition-colors duration-150",
            this.state.noneSelected ? "border-[#575757] bg-[#575757] text-white" : "border-[#a9a9a9] bg-white text-[#595959] hover:border-[#575757] hover:bg-[#575757] hover:text-white"
          ].join(" ");
          this.wheelNode.insertAdjacentHTML(
            "beforeend",
            `<button type="button" class="${noneClasses}" data-tw-action="none">None</button>`
          );
        }
      }
      const sizeOptions = this.state.noneSelected ? [] : [
        ...new Set(
          this.choices.filter((choice) => {
            if (this.state.wheel && choice.wheelLabel !== this.state.wheel) return false;
            return true;
          }).map((choice) => choice.tireSize).filter(Boolean)
        )
      ].sort(compareTireSizes);
      if (this.sizeNode) {
        this.sizeNode.innerHTML = "";
        sizeOptions.forEach((size) => {
          const isActive = size === this.state.tireSize;
          const classes = [
            "cursor-pointer rounded-[4px] border px-[15px] py-[13px] font-dinmedium text-[12px] font-medium uppercase leading-none tracking-tight transition-colors duration-150",
            isActive ? "border-[#575757] bg-[#575757] text-white" : "border-[#a9a9a9] bg-white text-[#595959] hover:border-[#575757] hover:bg-[#575757] hover:text-white"
          ].join(" ");
          this.sizeNode.insertAdjacentHTML(
            "beforeend",
            `<button type="button" class="${classes}" data-tw-action="size" data-size="${escapeHtml(size)}">${escapeHtml(size)}</button>`
          );
        });
      }
      const typeOptions = this.state.noneSelected ? [] : this.choices.filter((choice) => {
        if (this.state.wheel && choice.wheelLabel !== this.state.wheel) return false;
        if (this.state.tireSize && choice.tireSize !== this.state.tireSize) return false;
        return true;
      }).map((choice) => ({
        key: buildTypeKey(choice.type, choice.typeSub),
        type: choice.type,
        typeSub: choice.typeSub
      })).filter((item, index, all) => all.findIndex((entry) => entry.key === item.key) === index);
      if (this.typeNode) {
        this.typeNode.innerHTML = "";
        typeOptions.forEach((typeOption) => {
          const isActive = typeOption.key === this.state.typeKey;
          const classes = [
            "cursor-pointer inline-flex w-full min-w-0 flex-col items-center justify-center rounded-[4px] border px-[12px] py-[7px] text-center uppercase transition-colors duration-150 sm:w-auto sm:min-w-[108px]",
            isActive ? "border-[#575757] bg-[#575757] text-white" : "border-[#a9a9a9] bg-white text-[#595959] hover:border-[#575757] hover:bg-[#575757] hover:text-white"
          ].join(" ");
          this.typeNode.insertAdjacentHTML(
            "beforeend",
            `<button type="button" class="${classes}" data-tw-action="type" data-type-key="${escapeHtml(typeOption.key)}">
              <span class="block font-dinmedium text-[11px] font-medium leading-none tracking-tight">${escapeHtml(typeOption.type || "TYPE")}</span>
              <span class="mx-auto my-[3px] block h-px w-[34px] bg-current opacity-[0.55]"></span>
              <span class="block font-dinmedium text-[12px] font-medium uppercase leading-[1.3] opacity-[0.95]" style="font-style: normal;">${escapeHtml(formatTypeSubLabel(typeOption.typeSub))}</span>
            </button>`
          );
        });
      }
      const filteredChoices = this.state.noneSelected ? [] : this.choices.filter((choice) => {
        if (this.state.wheel && choice.wheelLabel !== this.state.wheel) return false;
        if (this.state.tireSize && choice.tireSize !== this.state.tireSize) return false;
        if (this.state.typeKey) {
          const key = buildTypeKey(choice.type, choice.typeSub);
          if (key !== this.state.typeKey) return false;
        }
        return true;
      });
      if (this.modelNode) {
        this.modelNode.innerHTML = "";
        filteredChoices.forEach((choice) => {
          const isActive = choice.id === this.state.choiceId;
          const displayModel = toStr(choice.model) || toStr(choice.productTitle) || "Tire model";
          const modelBadge = toStr(choice.discountBadge) || toStr(choice.tireBadge);
          const modelClasses = [
            "group w-full cursor-pointer flex flex-col items-center rounded-[4px] border px-[6px] pb-2.5 pt-0 text-center transition-colors duration-150 sm:px-[10px] sm:pb-4",
            isActive ? "border-[#575757] bg-[#575757]" : "border-[#c5c5c5] bg-white hover:border-[#c5c5c5] hover:bg-[#efefef]"
          ].join(" ");
          const modelCopyClass = isActive ? "text-white" : "text-[#3F3F3F]";
          const badgeHtml = modelBadge ? `<span data-tw-model-badge class="absolute left-[4px] top-[4px] z-[2] inline-flex max-w-[calc(100%-8px)] items-center justify-center rounded-full bg-[#e23d3d] px-[5px] py-[3px] text-center font-heading text-[8px] font-extrabold uppercase leading-none tracking-[0.03em] text-white shadow-[0_8px_18px_rgba(226,61,61,0.28)] sm:left-[8px] sm:top-[8px] sm:max-w-[calc(100%-16px)] sm:px-[8px] sm:py-[4px] sm:text-[11px] sm:tracking-[0.04em]">${escapeHtml(modelBadge)}</span>` : "";
          const imageHtml = choice.variantImage ? `<div class="relative mb-1 flex h-[76px] w-full items-center justify-center overflow-hidden rounded-[6px] bg-white sm:mb-1.5 sm:h-[100px] sm:rounded-[8px]">
                ${badgeHtml}
                <img data-tw-model-img class="h-full w-full object-contain object-center transition duration-150" src="${escapeHtml(choice.variantImage)}" alt="${escapeHtml(choice.model)}">
              </div>` : `<div class="relative mb-1 h-[76px] w-full rounded-[6px] sm:mb-1.5 sm:h-[100px] sm:rounded-[8px] ${isActive ? "bg-[#646464]" : "bg-[#ededed] group-hover:bg-[#dfdfdf]"}">
                ${badgeHtml}
              </div>`;
          const priceHtml = choice.variantPrice > 0 ? `(+${formatMoney(choice.variantPrice)})` : "";
          this.modelNode.insertAdjacentHTML(
            "beforeend",
            `<button type="button" class="${modelClasses}" data-tw-action="choice" data-choice-id="${escapeHtml(choice.id)}" data-tw-active="${isActive ? "true" : "false"}">
              ${imageHtml}
              <div class="w-full text-center font-heading text-[8px] font-bold uppercase leading-[1.1] tracking-tight sm:text-[11px] sm:leading-[1.15] ${modelCopyClass}">${escapeHtml(displayModel)}</div>
              <div class="w-full text-center font-dinmedium text-[8px] font-medium leading-none tracking-tight sm:text-[11px] ${modelCopyClass}">${escapeHtml(priceHtml)}</div>
            </button>`
          );
        });
      }
      if (this.emptyNode) {
        this.emptyNode.hidden = filteredChoices.length > 0;
      }
      const fitmentChoice = this.state.noneSelected ? null : this.getChoiceById(this.state.choiceId) || filteredChoices[0] || null;
      if (!fitmentChoice) {
        if (this.fitmentNode) this.fitmentNode.hidden = true;
      } else {
        const fitment = this.getResolvedFitment(fitmentChoice);
        const fitmentTitle1 = fitment.title1;
        const fitmentTitle2 = fitment.title2;
        const fitmentNote = fitment.note;
        if (this.fitmentTitle1Node) {
          this.fitmentTitle1Node.textContent = fitmentTitle1;
          this.fitmentTitle1Node.hidden = !fitmentTitle1;
        }
        if (this.fitmentTitle2Node) {
          this.fitmentTitle2Node.textContent = fitmentTitle2;
          this.fitmentTitle2Node.hidden = !fitmentTitle2;
        }
        if (this.fitmentNoteNode) {
          this.fitmentNoteNode.textContent = fitmentNote;
          this.fitmentNoteNode.hidden = !fitmentNote;
        }
        if (this.fitmentNode) {
          this.fitmentNode.hidden = !fitmentTitle1 && !fitmentTitle2 && !fitmentNote;
        }
      }
      this.updateProperties();
      this.updateDisplayPrices();
      this.dispatchEvent(
        new CustomEvent("tire-widget:change", {
          bubbles: true,
          detail: {
            addonCents: this.getSelectedAddonCents(),
            selectedChoiceId: this.state.choiceId || "",
            noneSelected: this.state.noneSelected
          }
        })
      );
    }
  }
  if (!window.customElements.get("tire-widget")) {
    window.customElements.define("tire-widget", TireWidget);
  }
})();
